import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const FONT_SIZES = {
  small: 'f7',
  regular: 'f41',
  large: 'f3',
}

const FONT_SIZES_OPTIONS = Object.keys(FONT_SIZES)

const Tag = ({ text, className, innerClassName, fontSize, small }) => {
  if (!text) {
    return null
  }

  const innerClasses = classNames(
    'dib br4',
    FONT_SIZES[fontSize],
    small ? 'h11 ph4 lh-solid-2' : 'h12 ph4 lh-copy',
    innerClassName
  )

  return (
    <span className={`dib f5 ${className}`}>
      <span className={innerClasses}>{text}</span>
    </span>
  )
}

Tag.defaultProps = {
  className: '',
  fontSize: 'regular',
  innerClassName: 'middle-gray bg-lighter-gray',
  small: true,
}

Tag.propTypes = {
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  fontSize: PropTypes.oneOf(FONT_SIZES_OPTIONS),
  small: PropTypes.bool,
  text: PropTypes.string,
}

export default Tag
